import Vue from 'vue'

import axios from 'axios'

// 配置请求的根路径
axios.defaults.baseURL = process.env.VUE_APP_baseUrl || process.env.baseUrl


// 请求拦截
axios.interceptors.request.use(config => {
    return config
}, err => {
    console.log(err);
    return Promise.error(err);
})

// 响应拦截
axios.interceptors.response.use(response => {
    return Promise.resolve(response);
})

export const request = (obj) => {
    let method = obj.method ? obj.method.toUpperCase() == "GET" ? "GET" : "POST" : "GET";
    return axios({
        method: method,
        url: obj.url,
        data: method == "POST" ? obj.params || {} : null,
        params: method == "GET" ? obj.params || {} : null,
    }).then(res => requestSuccess(obj, res))
        .catch(err => requestFail(obj, err))
}

const requestSuccess = (obj, res) => {
    let resData = res.data;
    if (typeof resData != 'object') {
        resData = JSON.parse(resData);
    }
    return Promise.resolve(resData)
}

const requestFail = (obj, res) => {
    console.log(obj.url, ',服务器错误');
}




// WEBPACK FOOTER //
// ./src/utils/request.js